import * as i0 from '@angular/core';
import { input, computed, TemplateRef, output, Component } from '@angular/core';
import { NgClass, NgTemplateOutlet } from '@angular/common';
import { NgxIcon } from '@digipay/ngx-icon';
import { NgxButtonComponent } from '@digipay/ngx-button';
const _c0 = a0 => ({
  "flex-row-reverse": a0
});
function NgxAlert_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵelement(1, "ngx-icon", 10);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", ctx_r0.icon())("iconSize", ctx_r0.sizeSm() ? "20px" : "24px");
  }
}
function NgxAlert_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", ctx_r0.sizeSm() ? "st-8" : "st-6");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.title(), " ");
  }
}
function NgxAlert_Conditional_8_ng_template_0_Template(rf, ctx) {}
function NgxAlert_Conditional_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, NgxAlert_Conditional_8_ng_template_0_Template, 0, 0, "ng-template", 8);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.templateText());
  }
}
function NgxAlert_Conditional_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.text(), " ");
  }
}
function NgxAlert_Conditional_10_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ngx-button", 12);
    i0.ɵɵlistener("clickHandler", function NgxAlert_Conditional_10_Conditional_1_Template_ngx_button_clickHandler_0_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.onActionClick("tinted"));
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵstyleMap("tinted-on-back");
    i0.ɵɵproperty("size", "small")("mode", "section");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.actionButton().tinted, " ");
  }
}
function NgxAlert_Conditional_10_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ngx-button", 12);
    i0.ɵɵlistener("clickHandler", function NgxAlert_Conditional_10_Conditional_2_Template_ngx_button_clickHandler_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.onActionClick("link"));
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵstyleMap("link");
    i0.ɵɵproperty("size", "small")("mode", "form");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.actionButton().link, " ");
  }
}
function NgxAlert_Conditional_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵtemplate(1, NgxAlert_Conditional_10_Conditional_1_Template, 2, 5, "ngx-button", 11)(2, NgxAlert_Conditional_10_Conditional_2_Template, 2, 5, "ngx-button", 11);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(3, _c0, ctx_r0.actionButtonAlign() === "end"));
    i0.ɵɵadvance();
    i0.ɵɵconditional(1, ctx_r0.actionButton().tinted ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(2, ctx_r0.actionButton().link ? 2 : -1);
  }
}
function NgxAlert_Conditional_11_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "ngx-icon", 13);
    i0.ɵɵlistener("click", function NgxAlert_Conditional_11_Template_ngx_icon_click_1_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.close());
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("iconSize", ctx_r0.sizeSm() ? "20px" : "24px");
  }
}
const ALERT_DEFAULT_CONFIG = {
  hasIcon: true,
  hasCloseIcon: true,
  color: 'blue',
  size: 'md',
  actionButtonAlign: 'start'
};
let NgxAlert = /*#__PURE__*/(() => {
  class NgxAlert {
    constructor(elementRef) {
      this.elementRef = elementRef;
      this.color = input(ALERT_DEFAULT_CONFIG.color);
      this.size = input(ALERT_DEFAULT_CONFIG.size);
      this.sizeSm = computed(() => this.size() === 'sm');
      this.title = input();
      this.text = input();
      this.templateText = computed(() => this.text() instanceof TemplateRef ? this.text() : null);
      this.hasIcon = input(ALERT_DEFAULT_CONFIG.hasIcon);
      this.icon = input('info-circle');
      this.hasCloseIcon = input(ALERT_DEFAULT_CONFIG.hasCloseIcon);
      this.actionButton = input();
      this.actionButtonAlign = input('start');
      this.hasButtons = computed(() => !!this.actionButton()?.link || !!this.actionButton()?.tinted);
      this.classes = computed(() => {
        const classArr = ['ngx-alert', `ngx-alert-${this.color()}`];
        return classArr.join(' ');
      });
      this.clickAction = output();
    }
    ngOnInit() {}
    close() {
      this.elementRef.nativeElement.remove();
    }
    onActionClick(actionType) {
      this.clickAction.emit(actionType);
    }
    static {
      this.ɵfac = function NgxAlert_Factory(t) {
        return new (t || NgxAlert)(i0.ɵɵdirectiveInject(i0.ElementRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: NgxAlert,
        selectors: [["ngx-alert"]],
        inputs: {
          color: [i0.ɵɵInputFlags.SignalBased, "color"],
          size: [i0.ɵɵInputFlags.SignalBased, "size"],
          title: [i0.ɵɵInputFlags.SignalBased, "title"],
          text: [i0.ɵɵInputFlags.SignalBased, "text"],
          hasIcon: [i0.ɵɵInputFlags.SignalBased, "hasIcon"],
          icon: [i0.ɵɵInputFlags.SignalBased, "icon"],
          hasCloseIcon: [i0.ɵɵInputFlags.SignalBased, "hasCloseIcon"],
          actionButton: [i0.ɵɵInputFlags.SignalBased, "actionButton"],
          actionButtonAlign: [i0.ɵɵInputFlags.SignalBased, "actionButtonAlign"]
        },
        outputs: {
          clickAction: "clickAction"
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        decls: 12,
        vars: 7,
        consts: [[3, "ngClass"], [1, "d-flex", "justify-content-flex-start", "gap-low"], [1, "ngx-alert-icon"], [1, "d-flex", "flex-column", "gap-minus"], [1, "d-flex", "justify-content-flex-start"], [1, "d-flex", "flex-column", "gap-tiny"], [1, "text-onback-high", 3, "ngClass"], [1, "text-onback-medium", 3, "ngClass"], [3, "ngTemplateOutlet"], [1, "d-flex", "gap-small", 3, "ngClass"], ["type", "Linear", 3, "name", "iconSize"], [3, "size", "style", "mode"], [3, "clickHandler", "size", "mode"], ["name", "close", "type", "Linear", "classes", "cursor-pointer text-onback-low", 3, "click", "iconSize"]],
        template: function NgxAlert_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
            i0.ɵɵtemplate(2, NgxAlert_Conditional_2_Template, 2, 2, "div", 2);
            i0.ɵɵelementStart(3, "div", 3)(4, "div", 4)(5, "div", 5);
            i0.ɵɵtemplate(6, NgxAlert_Conditional_6_Template, 2, 2, "div", 6);
            i0.ɵɵelementStart(7, "div", 7);
            i0.ɵɵtemplate(8, NgxAlert_Conditional_8_Template, 1, 1, null, 8)(9, NgxAlert_Conditional_9_Template, 1, 1);
            i0.ɵɵelementEnd()()();
            i0.ɵɵtemplate(10, NgxAlert_Conditional_10_Template, 3, 5, "div", 9);
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(11, NgxAlert_Conditional_11_Template, 2, 1, "div");
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngClass", ctx.classes());
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(2, ctx.hasIcon() ? 2 : -1);
            i0.ɵɵadvance(4);
            i0.ɵɵconditional(6, ctx.title() ? 6 : -1);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngClass", ctx.sizeSm() ? "b-3" : "b-2");
            i0.ɵɵadvance();
            i0.ɵɵconditional(8, ctx.templateText() ? 8 : 9);
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(10, ctx.hasButtons() ? 10 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(11, ctx.hasCloseIcon() ? 11 : -1);
          }
        },
        dependencies: [NgClass, NgxIcon, NgxButtonComponent, NgTemplateOutlet],
        styles: [".ngx-alert[_ngcontent-%COMP%]{direction:rtl;display:flex;align-items:flex-start;justify-content:space-between;border-radius:20px;max-width:533px;gap:6px;padding:12px}.ngx-alert-blue[_ngcontent-%COMP%]{background:var(--surface-brand-tint)}.ngx-alert-blue[_ngcontent-%COMP%]   .ngx-alert-icon[_ngcontent-%COMP%]{color:var(--text-onback-brand)}.ngx-alert-red[_ngcontent-%COMP%]{background:var(--surface-error-tint)}.ngx-alert-red[_ngcontent-%COMP%]   .ngx-alert-icon[_ngcontent-%COMP%]{color:var(--text-onback-error)}.ngx-alert-yellow[_ngcontent-%COMP%]{background:var(--surface-warning-tint)}.ngx-alert-yellow[_ngcontent-%COMP%]   .ngx-alert-icon[_ngcontent-%COMP%]{color:var(--text-onback-warning)}.ngx-alert-green[_ngcontent-%COMP%]{background:var(--surface-success-tint)}.ngx-alert-green[_ngcontent-%COMP%]   .ngx-alert-icon[_ngcontent-%COMP%]{color:var(--text-onback-success)}.ngx-alert-gray[_ngcontent-%COMP%]{background:var(--surface-back)}.ngx-alert-gray[_ngcontent-%COMP%]   .ngx-alert-icon[_ngcontent-%COMP%]{color:var(--text-onback-low)}"]
      });
    }
  }
  return NgxAlert;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * Public API Surface of ngx-alert
 */

/**
 * Generated bundle index. Do not edit.
 */

export { ALERT_DEFAULT_CONFIG, NgxAlert };
